import { vendorPreserve } from "@pages/ManualDocumentV2/forms/_shared/preserve";
import { RectificationReason } from "@pages/ManualDocumentV2/invoice/RectificationReason";
import { ComplianceDocumentType } from "@utils/documentSeriesEnum";
import {
  branchByInvoiceType,
  defineForm,
  MANUAL_DOC_ENDPOINTS,
} from "../../../../core";
import { siiCorrectiveInvoiceSchema } from "./schema";

export const siiCorrectiveInvoiceConfig = defineForm({
  id: "sii_corrective_invoice",
  createEndpoint: branchByInvoiceType(
    MANUAL_DOC_ENDPOINTS.SII_CORRECTIVE_ON_REGULAR,
    MANUAL_DOC_ENDPOINTS.SII_CORRECTIVE_ON_SIMPLIFIED_R5,
  ),
  permission: "ManualDocumentsIN_Write",
  seriesPermission: "ManualDocumentsSeries_Read",
  documentClass: "Invoice",
  accountClass: "AccountReceivable",
  taxRatesChannel: "SII",
  invoiceType: "correctiveInvoice",
  complianceType: ComplianceDocumentType.CorrectiveInvoice,
  requiresLegalRep: true,
  titleKey: "corrective_invoice",
  complianceStandardKey: "sii",
  schema: siiCorrectiveInvoiceSchema,
  preserveOnReset: vendorPreserve,
  sections: {
    customer: { hiddenFields: ["customerCompanyAddress"] },
    document: {
      extraFields: [
        {
          id: "rectificationReason",
          render: ({ translate }) => <RectificationReason {...{ translate }} />,
        },
      ],
    },
  },
  omitFromPayload: ["customerCompanyAddress"],
});
